import styled, { css } from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export const DivStyled = styled.div`
  ${({ theme }) => {
    const xlargeUp = theme.xlargeUp();
    const mediumUp = theme.mediumUp();
    let marginTop = rem(2);

    if(xlargeUp){
      marginTop = rem(1);
    }else if(mediumUp){
      marginTop = rem(4);
    }

    return css`
      margin-top: ${marginTop};
      padding: 0;
      .nmx-icon {
        width: 100%;
        height: ${mediumUp ? rem(50) : rem(30)};
      }
    `;
  }}
`;
export const TypographyStyled = styled(Typography)`
  ${({ theme }) => {
    const mediumUp = theme.mediumUp();
    return css`
      ${!mediumUp &&  `padding-bottom: ${rem(20)};`};
    `;
  }}
`;
